var validateInputRange = function validateInputRange(min, max, value) {
  return typeof value === 'string' ? 0 : Math.min(Math.max(value, min), max);
};

export { validateInputRange as default };
//# sourceMappingURL=index.js.map
